<template>
	<div class="content_box">
		<div class="title">
			<span class="left_shu"></span>
			群组
		</div>
		<div class="operation">
			<a-button class="creatadd" type="primary" @click="addModal">
				创建组别
			</a-button>
			<div class="sinput">
				<input type="text" placeholder="请输入组别查询" />
				<img src="../../assets/image/37.png" />
			</div>
		</div>
		<a-table :columns="columns" :data-source="data">
			<span slot="tags" slot-scope="text,tags">
				<a class="edit_btn" @click="() => editModal(tags)">编辑</a>
				<a class="delete_btn" @click="() => deleteBtn(tags)">删除</a>
			</span>
		</a-table>

		<!-- 添加弹窗 -->
		<div class="addbox" ref="add">
			<a-modal v-model="visible" :title="title" @ok="handleOk" :getContainer="()=>$refs.add" okText="确认"
				cancelText="取消" width='490px'>
				
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="2" :order="1">
							<div class="frame_list_title">
								组名
							</div>
						</a-col>
						<a-col :span="10" :order="2">
							<a-input type="text" style="width: 150px;" v-model='projectForm.division' />
						</a-col>
						
					</a-row>
				</div>
				<div class="frame_list_box">
					<a-row type="flex">
						<a-col :span="2" :order="1">
							<div class="frame_list_title">
								描述
							</div>
						</a-col>
						<a-col :span="20" :order="2">
							<a-textarea style="height: 150px;" v-model='projectForm.remark'></a-textarea>
						</a-col>
					</a-row>
				</div>
				
			</a-modal>
		</div>

	</div>
</template>

<script>
	const columns = [{
			title: '序号',
			dataIndex: 'id',
			align: 'center',
		},
		{
			title: '组别',
			dataIndex: 'division',
			align: 'center',
		},
		{
			title: '说明',
			dataIndex: 'remark',
			align: 'center',
		},
		{
			title: '创建时间',
			dataIndex: 'creatime',
			align: 'center',
		},
		{
			title: '操作',
			dataIndex: 'tags',
			scopedSlots: {
				customRender: 'tags'
			},
			align: 'center',
			width: '120px'
		},
	];

	const data = [{
			id: '1',
			division: '一组',
			remark: '组别说明',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '2',
			division: '一组',
			remark: '组别说明',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '3',
			division: '一组',
			remark: '组别说明',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '4',
			division: '一组',
			remark: '组别说明',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '5',
			division: '一组',
			remark: '组别说明',
			creatime: '2021-01-08 13:58:03',
		},
	];

	export default {
		data() {
			return {
				data, //表格内容
				columns, //表格头部
				temporary: [{
						id: '1',
						division: '一组',
						remark: '组别说明',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '2',
						division: '一组',
						remark: '组别说明',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '3',
						division: '一组',
						remark: '组别说明',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '4',
						division: '一组',
						remark: '组别说明',
						creatime: '2021-01-08 13:58:03',
					},
					{
						id: '5',
						division: '一组',
						remark: '组别说明',
						creatime: '2021-01-08 13:58:03',
					},
				],
				visible: false,
				title: '', //弹框表提
				projectForm: {
					division: '', //组名
					remark: '', //描述
				},
				
			};
		},
		methods: {
			addModal(e) {
				console.log(e)
				this.data = this.temporary
				Object.keys(this.projectForm).forEach(
					(key) => (this.projectForm[key] = "")
				);
				this.title = '创建组别'
				this.visible = true;
			},
			editModal(tags) {
				console.log(tags)
				var data = tags
				this.projectForm = data
				this.title = '编辑组别'
				this.visible = true;
			},
			handleOk(e) {
				this.visible = false;
			},
			handleChange(value) {
				console.log(value); // { key: "lucy", label: "Lucy (101)" }
			},
		},

	};
</script>

<style scoped>
	@import url("../../assets/css/common.css");

	.edit_btn {
		float: left;
		color: #7F86E9;
		font-size: 12px;
		padding: 0 10px;
		text-decoration: underline;
	}

	.delete_btn {
		color: #999999;
		font-size: 12px;
		padding-right: 10px;
		text-decoration: underline;

	}
	
	.ant-col-20{
		padding-top: 12px;
	}
	
</style>
